import React from "react";

import CardBox from "../../../components/CardBox";
import "./style.scss";
import AdminFooter from "../../../components/AdminFooter";
import AdminHeader from "../../../components/AdminHeader";

export default function Dashboard() {
  return (
    <div className="dashboard-main">
      <AdminHeader />
      <div className="dashboard-box">
        <CardBox />
      </div>
      <AdminFooter />
    </div>
  );
}
